export default __webpack_public_path__ + "static/media/RAMADA02.d10d2ecd.jpg";